import { Injectable } from '@angular/core';
import { Permission, PermissionCode } from '../models/permission';
import { EventService } from './events';
import { EVENTS } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PermissionStore {
  private _permissions: Permission[] = [];
  private _isLoaded: boolean = false;

  constructor(private events: EventService) {
    this.events.eventEmitter.subscribe(({ event }) => {
      if (event === EVENTS.SESSION_END) {
        this.clear();
      }
    });
  }

  get permissions(): Permission[] {
    return this._permissions;
  }

  set permissions(perms: Permission[]) {
    this._permissions = perms;
    this._isLoaded = true;
  }

  get isLoaded(): boolean {
    return this._isLoaded;
  }

  hasPermission(code: PermissionCode | string): boolean {
    return this._permissions.some(p => p.code === code);
  }

  clear(): void {
    this._permissions = [];
    this._isLoaded = false;
  }
}
